import { FC } from 'react';

// Quarks
import Flex from 'quarks/Flex';

import ComparisonCard from 'components/Cards/ComparisonCard';

import type { ContentfulComponentCardDeck } from 'graphqlTypes';

const ComponentCardDeck: FC<ContentfulComponentCardDeck> = ({ card, backgroundIsDark, ...props }) => (
  <Flex flexDirection="column" gap="48px" overflowX="hidden" overflowY="hidden" {...props}>
    {card && card.length > 0 && (
      <Flex width="100%" maxWidth="100%" marginX="auto" flexWrap="wrap" gap="30px">
        {card.map(item => (
          <Flex
            key={item?.id}
            width="100%"
            maxWidth="100%"
            md={{ maxWidth: 'calc((100% - 30px) / 2)' }}
            lg={{ maxWidth: 'calc((100% - 60px) / 3)' }}
          >
            <ComparisonCard backgroundIsDark={backgroundIsDark} {...item} />
          </Flex>
        ))}
      </Flex>
    )}
  </Flex>
);

export default ComponentCardDeck;
